import React from 'react';

import EmojiIcon from '@pkg/assets/icons/v2/emoji.svg?react';
import { CircleButton } from '@pkg/components';

import './InputStateBlurButton.scss';

const InputStateBlurButton = () => {
    const resetPickerSearch = () => {
        // reset the search
    };

    return (
        <CircleButton
            classes="input-state-blur-button"
            onClick={resetPickerSearch}
            ariaLabel=""
            aria-hidden="true"
            size="large"
        >
            <EmojiIcon className="input-state-blur-button__icon" />
        </CircleButton>
    );
};

export default InputStateBlurButton;
